import favoritedStores from './favoritedStores';

export default favoritedStores;
